import styled from 'styled-components';

const DifficultyIcon = styled.img`
  width: 17px;
  margin-right: 0.5rem;
`;

export default DifficultyIcon;
